<template>
  <div
      class="firmware-input-component device-row-details">
    <div class="ring-card__input-label">
      <h3 style="display: inline-block;">
        {{ component.name | capitalize }}
      </h3>
      <el-tooltip
          class="item"
          effect="dark"
          :content="tooltipText"
          placement="top-start">
        <i
            :class="iconName"
            style="margin-left: 1rem;"></i>
      </el-tooltip>
    </div>
    <p
        style="width: max-content;"
        class="ring-card__input">
      <span v-if="editMode === false">{{ currentFirmware.version || 'Not set' }}</span>
      <el-select
          v-else
          v-model="component.newVersionSelected"
          size="small"
          placeholder="Not set"
          filterable
          :disabled="!editMode">
        <el-option-group
            v-for="group in fwGroupedByRelease"
            :key="group.label"
            :label="group.label">
          <el-option
              v-for="item in group.options"
              :key="item.id"
              :label="item.version"
              :value="item.version" />
        </el-option-group>
      </el-select>
    </p>
    <small style="color: forestgreen;">
      Running {{ runningFirmware }}
    </small>
  </div>
</template>

<script>
import { get, upperFirst, isEmpty } from "lodash";
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("db/device");
export default {
  name: "FirmwareInput",
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Object,
      required: true,
      default: () => {
        return {
          newVersionSelected: null,
          name: "",
          type: "",
        };
      },
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultFirmware: {
      type: Object,
      required: true,
    },
    firmwareAssigned: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      fwGroupedByRelease: [],
      selected: null,
      assigned: "",
    };
  },
  computed: {
    ...mapGetters(["lastStatusReport", "device"]),
    tooltipText() {
      return this.assignedFwIsRunning ? "Currently Running" : "Not Running";
    },
    iconName() {
      return this.assignedFwIsRunning
        ? "el-icon-success success"
        : "el-icon-warning warning";
    },
    assignedFwIsRunning() {
      return this.runningFirmware === this.firmwareAssigned.version;
    },
    runningFirmwares() {
      return get(this.lastStatusReport, "data.firmware_versions", {}) || [];
    },
    runningFirmware() {
      let versions = this.runningFirmwares;
      return versions[this.uglyHackGetComponentName()] || "(not found)";
    },
    hasDefault() {
      return this.defaultFirmware.version;
    },
    defaultFirmwareVersion() {
      return this.defaultFirmware.version;
    },
    currentFirmware() {
      return isEmpty(this.firmwareAssigned)
        ? this.defaultFirmware
        : this.firmwareAssigned;
    },
  },
  watch: {
    editMode(editing) {
      if (editing === false) return;
      let { component, version } = this.firmwareAssigned;
      if ((component && version) === false) return;

      let fw = this.options.find((f) => {
        return f.version === version;
      });
      this.component.newVersionSelected = get(
        fw,
        "version",
        this.currentFirmware.version
      );
    },
    options(list) {
      this.fwGroupedByRelease = list.reduce((groups, component) => {
        let key = component.release;
        try {
          groups[key].options.push(component);
        } catch (e) {
          groups[key] = { label: upperFirst(key), options: [component] };
        }
        return groups;
      }, {});
    },
  },
  created() {},
  methods: {
    uglyHackGetComponentName() {
      /*  In  Status Report, for some device types the version of <<sys>> component -
          will appear under the name of <<flash>>
          ¯\_(ツ)_/¯
          Running Version are the versions that appear in the last status report
       */
      const componentName = this.component.name;
      const sysComponentIsMissing =
        this.runningFirmwares.hasOwnProperty("sys") === false;
      if (componentName === "sys" && sysComponentIsMissing) return "flash";
      return componentName;
    },
  },
};
</script>

<style lang="scss">
.firmware-input-component.device-row-details {
  margin-bottom: 14px;
  padding-left: 40px;
  .text-in-parenthesis {
    &:before,
    &:after {
      color: $--color-silver;
    }
    &:before {
      content: "(";
    }
    &:after {
      content: ")";
    }
  }
  .info {
    color: $--color-silver;
  }
  .up-to-date {
    color: $--color-dusty-gray;
  }
  .outdated {
    color: $--color-curious-blue;
  }
  .default-row {
    margin-left: 5px;
  }
  p {
    margin: 0px;
    font-size: 17px;
  }
  .warning {
    color: $--color-flamingo;
  }
  .success {
    color: $--color-fun-green;
  }
}
</style>
